export const setFlutterNav = (show: boolean) => window.DisplayNativeNav?.postMessage(JSON.stringify(show));
